import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "set-bank pt-2 pb-4 mx-3" }
const _hoisted_2 = {
  key: 1,
  class: "pb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_StepBar = _resolveComponent("StepBar")!
  const _component_BottomFormActionButtons = _resolveComponent("BottomFormActionButtons")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BankAccountForm = _resolveComponent("BankAccountForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, _createSlots({
      default: _withCtx(() => [
        _createTextVNode("\n      振込口座\n    ")
      ], undefined, true),
      _: 2
    }, [
      (_ctx.needBackButton)
        ? {
            name: "left",
            fn: _withCtx(() => [
              _createVNode(_component_FeatherIcon, {
                icon: "chevron-left",
                onClick: _ctx.routerBack
              }, null, 8, ["onClick"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.needStepBar)
        ? (_openBlock(), _createBlock(_component_StepBar, {
            key: 0,
            maxValue: 4,
            currentValue: 3,
            class: "mb-3"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2)),
      _createTextVNode(),
      _createVNode(_component_CustomValidationObserver, {
        initialValues: _ctx.formValues,
        ref: "form"
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_BankAccountForm, {
            modelValue: _ctx.inputValues,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValues) = $event)),
            banks: _ctx.banks
          }, {
            footerButton: _withCtx(() => [
              (_ctx.needBottomActionButtons)
                ? (_openBlock(), _createBlock(_component_BottomFormActionButtons, {
                    key: 0,
                    skipButtonText: "スキップする",
                    onSubmit: ($event: any) => (handleSubmit(_ctx.onClickSubmitButton)),
                    onSkip: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('skipped')))
                  }, null, 8, ["onSubmit"]))
                : (_openBlock(), _createBlock(_component_AppButton, {
                    key: 1,
                    block: "",
                    class: "mt-4",
                    variant: "success",
                    onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmitButton)),
                    disabled: _ctx.isSubmittingDisabled
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("設定する")
                    ], undefined, true),
                    _: 2
                  }, 1032, ["onClick", "disabled"]))
            ]),
            _: 2
          }, 1032, ["modelValue", "banks"])
        ]),
        _: 1
      }, 8, ["initialValues"])
    ])
  ]))
}